// extracted by mini-css-extract-plugin
export default {"-large":"cropping-preset-item-module__-large--Qnl4n","iconBox":"cropping-preset-item-module__iconBox--e5t3G"};